import {useAttendeeVariables} from 'Event'
import styled from 'styled-components'
import {useTemplate} from 'Event/TemplateProvider'
import HTMLContent from 'lib/ui/form/HTMLEditor/HTMLContent'
import Configurable from 'organization/Event/Configurable'
import React from 'react'
import WaiverConfig from 'Event/Step2/Waivers/Description/WaiverConfig'

export default function Description() {
  const v = useAttendeeVariables()

  const {waiver} = useTemplate()

  return (
    <Configurable>
      <WaiverConfig />
      <StyledContent>{v(waiver.description)}</StyledContent>
    </Configurable>
  )
}

const StyledContent = styled(HTMLContent)`
  max-height: 100%;
  overflow-y: auto;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 24px;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 32px;
  }
`
